import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
/*--------------------------GET ALL PARTNERS---------------------------*/
export const getAllPartners = createAsyncThunk("partners/get-partners", async () => {
  try {
    const response = await axios.get(`${baseUrlApi}partners/success`);
    return response?.data;
  } catch (error) {
    throw error;
  }
});
